
export const serviceBaseUrl = "/api";

export const staticFileBaseUrl = '/api/static/documents/';
export const staticImageBaseUrl = '/api/static/images/';
